import pagesRegistry from '../../app/assets/json/pages.json';

type PagesRegistry = Record<string, { title: string; path: string; icon: string; order: number }>;

const registry = pagesRegistry as PagesRegistry;

const pathToPageId = new Map<string, string>();
for (const [pageId, page] of Object.entries(registry)) {
	pathToPageId.set(page.path, pageId);
}

/** Resolve a registered pageId from an exact path match, else null. */
export function pageIdFromPath(path: string): string | null {
	return pathToPageId.get(path) ?? null;
}
